(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CallTypeDeleteController',CallTypeDeleteController);

    CallTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CallType'];

    function CallTypeDeleteController($uibModalInstance, entity, CallType) {
        var vm = this;
        vm.callType = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            CallType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
